<template>
  <!-- eslint-disable -->
    <div id="widget-app">
      <div class="p-1">
        <div class="card">
          <div class="card-body wizard wizard-default">
            <form-wizard :with-validate="true" :last-step-end="true" :nav-class=" 'justify-content-between'">
              <tab name="1" :desc="'Recherche'" :selected="true"  :validate="validateSearch" :submit="submitSearch">
                <div class="wizard-basic-step">
                  <Search ref="search" v-on:do-search="doSetSearch"/>
                </div>
              </tab>
              <tab name="2" :desc="'Agenda'"   :validate="validateStep1" :submit="submitStep1">
                <div class="wizard-basic-step">
                  <Calendar ref="calendar" v-on:do-selected-date="doSelectDate" v-bind:init-date="date"  />
                </div>
              </tab>
              <tab name="3" :desc="'Participants'"   :validate="validateStep2" :submit="submitStep2">
                <div class="wizard-basic-step">
                  <Client ref="client"  v-on:do-user-info="doSetUserInfo" v-bind:init-user="user" :max-total="total"/>
                </div>
              </tab>
              <tab name="4" :desc="'Previews'"  :validate="validateStep3" :submit="submitStep3">
                <div class="wizard-basic-step" v-if="user && date">
                  <Previews v-bind:date="date" v-bind:user="user"  v-on:do-save="doSaveInfo"  v-on:do-update="doUpdate"/>
                </div>
              </tab>
              <tab type="done">
                <div class="wizard-basic-step wizard-success-msg text-center pt-3">

                  <div v-if="isProcessing">
                    <spinner variant="primary" label="Spinning" class="mb-1"></spinner>
                    <p>Async save for 3 seconds!</p>
                  </div>
                  <div v-else>
                    <div md="6" >
                                    <span class="icon">
                                        <img src="../assets/check.png" alt="">
                                    </span>
                      <h2 class="mb-3 mt-3">Peam créé avec succès !</h2>
                      <p>Nous vous remercions pour votre reservation, un sms va vous être adressé pour proceder au reglement, qui valide cette reservation.</p>
                    </div>
                  </div>

                </div>
              </tab>
            </form-wizard>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import FormWizard from "./Form/Wizard/FormWizard";
    import spinner from "./spinner";
    import Tab from "./Form/Wizard/Tab";
    import Calendar from "./Calendar";
    import Client from "./Client";
    import Previews from "./Previews";
    import Search from "./Search";
    export default {
        name: "Widget",
        components: {
          Calendar,
          Client,
          Previews,
          spinner,
          Search,
          "form-wizard": FormWizard,
          tab: Tab,
        },
        data() {
            return {
                step:1,
                isProcessing:false,
                date:null,
                total:0,
                user:null,
                search:null,
            };
        },
        computed: {

        },
        methods: {
          submitSearch() {
            //return true;
          },
          validateSearch() {
            this.$refs.search.submit();
            return  this.search ? true : false;
          },
          submitStep1(){

          },
          validateStep1(){
            return this.date ? true : false;
          },
          submitStep2(){
            console.log("submitStep2");
           // this.$refs.client.submit();
          },
          validateStep2(){
            console.log("validateStep2");
            this.$refs.client.submit();
            return  this.user ? true : false;
          },
          submitStep3(){
            console.log("submitStep3");
           // this.$refs.client.submit();
            this.isProcessing = true;
            return window.PublicAxios.post('/commercant/'+window.info.refCom+'/prestation/'+window.info.refPrestation+'/calendar', {
              mobile:this.user.formattedPhone,
              nom:this.user.lastname,
              prenom:this.user.firname,
              paxs:this.user.participants.map((item)=>{
                return {
                  nom:item.lastname,
                  prenom:item.firname,
                  mobile:item.phone,
                }
              }),
              reservation_date:this.date,
              paiement_type:window.info.typePaiement,
              total:"10",
              }).then(()=>{
              this.isProcessing = false;
            }).catch(()=>{
              this.isProcessing = false;
            })
          },
          validateStep3(){
            return true
          },
          doSelectDate({date,total, nb_participants_dispo}){
            this.date = date;
            this.total = nb_participants_dispo;
            this.step ++;
            this.$refs.client.initDefautlForm(this.search );
            this.$refs.client.prepareFieldParticipant(this.search.nbparticipants -1 );
            console.log("date",date,total, nb_participants_dispo);
          },
          doSetUserInfo({user}){
            this.user = user;
            this.step ++,
            console.log("user",user);
          },
          doSetSearch({form}){
            this.search = form;
            this.step ++;
            this.$refs.calendar.searchByDate(form.date, form.nbparticipants);
          },
          doSaveInfo(){

          },
          doUpdate(){
            this.step = 1;
          }
        },
        created() {

        },
    }
</script>
